import { TnAOverviewDTO } from "../../models/tna-overviews";
import { BaseApiService } from "../base/base-api.service";
import { ListSortDirection } from "../../models/api/sort/list-sort-direction";
import { Sort } from "../../models/api/sort/sort";
import { STOModel } from "src/models/base/sto-model";

export class TnAOverviewsApiService extends BaseApiService<TnAOverviewDTO, STOModel> {
  constructor() {
    super({
      servicePath: "/TnAOverviews",
      loadItemsPath: "/GetTnAOverviews",
    });
    this.defaultSort = [
      {
        name: "workedTimeBalance",
        direction: ListSortDirection.Descending,
      } as Sort,
    ];
  }
}
